export default __webpack_public_path__ + "static/1-51548fcced6ec56fd6017c189b6ee21f.png";